module.exports = __webpack_public_path__ + "img/saldoCuentas.7797d191.svg";